import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

interface FeaturedProductsProps {
  language: 'tr' | 'en';
}

const products = [
  {
    image: process.env.PUBLIC_URL + '/uyumtakip-logo.png',
    title: { tr: 'UyumTakip', en: 'UyumTakip' },
    desc: {
      tr: 'Finansal kuruluşlar ve yükümlü işletmeler için MASAK uyum ve müşteri yönetimi yazılımı. Müşteri tanıma, AML sorgulama, evrak ve işlem takibini tek platformda toplar.',
      en: 'MASAK compliance and customer management software for financial institutions and obliged businesses. Brings customer onboarding, AML screening, document and transaction tracking into a single platform.',
    },
    detail: { tr: 'Detaylı Bilgi', en: 'More Info' },
    slug: 'uyumtakip',
  },
];

const FeaturedProducts: React.FC<FeaturedProductsProps> = ({ language }) => {
  return (
    <motion.section
      id="services"
      className="py-12 bg-white scroll-mt-24"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: 'easeOut' }}
      viewport={{ once: false, amount: 0.2 }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-8 text-left">
          {language === 'tr' ? 'Öne Çıkan Ürünler' : 'Featured Products'}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, idx) => (
            <div
              key={idx}
              className="rounded-xl overflow-hidden shadow-lg group flex flex-col bg-white border border-gray-100 hover:shadow-xl transition-shadow"
            >
              <div className="h-48 flex items-center justify-center bg-gradient-to-br from-yellow-50 via-white to-gray-50 p-8">
                <img
                  src={product.image}
                  alt={product.title[language]}
                  className="max-h-20 w-auto object-contain transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{product.title[language]}</h3>
                <p className="text-base text-gray-600 mb-5 flex-1">{product.desc[language]}</p>
                <Link
                  to={`/${language}/investment/${product.slug}`}
                  className="inline-block self-start bg-red-600 hover:bg-red-700 text-white font-semibold px-5 py-2 rounded shadow transition-colors"
                >
                  {product.detail[language]} →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default FeaturedProducts;
